import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, MessageSquare, LogOut, ArrowLeft, CreditCard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/settings/razorpay", label: "Payments", icon: CreditCard },
];

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const isActive = (item) =>
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);

  return (
    <div className="flex min-h-screen bg-[#F3F4F6]" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 z-40 flex h-screen w-16 flex-col justify-between border-r border-black/10 bg-[#0A2540] py-6 lg:w-60">
        <div>
          <Link to="/" className="mb-10 flex items-center gap-2 px-4 font-display text-base font-extrabold tracking-tight text-white lg:justify-start justify-center">
            <img src="/logo-icon.png" alt="Physio Essential" className="h-8 w-8 object-contain" />
            <span className="hidden lg:inline">Physio<span className="font-medium text-[#34D8A0]"> essential</span></span>
          </Link>
          <nav className="space-y-1 px-2">
            {NAV.map((item) => {
              const Icon = item.icon;
              const active = isActive(item);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center gap-3 rounded-md px-3 py-3 font-mono text-xs uppercase tracking-overline transition-colors ${
                    active ? "bg-[#2F80ED] text-white" : "text-white/50 hover:bg-white/5 hover:text-white"
                  }`}
                  data-testid={`admin-nav-${item.label.toLowerCase()}`}
                >
                  <Icon className="h-4 w-4 shrink-0" />
                  <span className="hidden lg:inline">{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="space-y-1 px-2">
          <button
            onClick={() => navigate("/")}
            className="flex w-full items-center gap-3 rounded-md px-3 py-3 font-mono text-xs uppercase tracking-overline text-white/50 hover:bg-white/5 hover:text-white"
            data-testid="admin-back-store"
          >
            <ArrowLeft className="h-4 w-4 shrink-0" />
            <span className="hidden lg:inline">Store</span>
          </button>
          <button
            onClick={logout}
            className="flex w-full items-center gap-3 rounded-md px-3 py-3 font-mono text-xs uppercase tracking-overline text-white/50 hover:bg-white/5 hover:text-white"
            data-testid="admin-logout"
          >
            <LogOut className="h-4 w-4 shrink-0" />
            <span className="hidden lg:inline">Log out</span>
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="ml-16 flex-1 lg:ml-60">
        <Outlet />
      </main>
    </div>
  );
}
